<template>
    <toolbar-option>
        <template slot="primary">
            <div class="f-flex f-justify-between f-items-center f-mt-0.25 f-mb-1">
                <div class="f-w-5/10">
                    <calendar-facet-weekdays-color
                        :value="weekdays.color"
                        @input="onColorInput"
                    />
                </div>
                <div class="f-w-5/10">
                    <calendar-facet-weekdays-bgcolor
                        :value="weekdays.backgroundColor"
                        @input="onBackgroundColorInput"
                    />
                </div>
            </div>
            <calendar-facet-weekdays-font-family
                :value="weekdays.font"
                @input="onFontInput"
            />
            <calendar-facet-weekdays-font-size
                :value="weekdays.size"
                @input="onFontSizeInput"
            />
            <calendar-facet-weekdays-font-style
                :value="weekdays.style"
                @input="onFontStyleInput"
            />
            <calendar-facet-weekdays-font-weight
                :value="weekdays.weight"
                @input="onFontWeightInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'calendar-facet-weekdays';

export default {
    name: 'calendar-facet-weekdays',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Weekdays Options',
            message: '',
            value: '',
            checked: false,
            weekdays: {
                color: '',
                font: '',
                weight: 'vc-font-bold',
                size: 'vc-text-sm',
                style: '',
                backgroundColor: '',
            },
        };
    },

    methods: {
        onColorInput(cssClass) {
            this.weekdays.color = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.weekdays);
            this.selectedElements[0].weekdaysFontColorClass = cssClass;
        },

        onBackgroundColorInput(cssClass) {
            this.weekdays.backgroundColor = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.weekdays);
            this.selectedElements[0].weekdaysBackgroundColorClass = cssClass;
        },

        onFontInput(cssClass) {
            this.weekdays.font = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.weekdays);
            this.selectedElements[0].weekdaysFontClass = cssClass;
        },

        onFontSizeInput(cssClass) {
            this.weekdays.size = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.weekdays);
            this.selectedElements[0].weekdaysFontSizeClass = cssClass;
        },

        onFontStyleInput(cssClass) {
            this.weekdays.style = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.weekdays);
            this.selectedElements[0].weekdaysFontStyleClass = cssClass;
        },

        onFontWeightInput(cssClass) {
            this.weekdays.weight = cssClass;
            this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.weekdays);
            this.selectedElements[0].weekdaysFontWeightClass = cssClass;
        },

        onSelectedElement() {
            this.weekdays = this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME) ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) : this.weekdays;
        },
    },
};
</script>
